import React, { useMemo } from "react";
import { Select, Spin } from "antd";
import { useTranslation } from "react-i18next";
import ConditionalWrapper from "misc/conditional/ConditionalWrapper";
import { useCustomers } from "misc/api/keycloakApi";

const CustomerSelector = ({ verbose = true, ...props }) => {
    const [t] = useTranslation();
    const { customers, customersQueryState } = useCustomers();

    const options = useMemo(() => {
        return customers.map(customer => ({
            label: customer.name,
            value: customer.id
        }));
    }, [verbose, t, customers]);

    return (
        <ConditionalWrapper condition={customersQueryState.isLoading} wrapper={children => <Spin indicator={null}>{children}</Spin>}>
            <Select
                filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                options={options}
                showSearch
                {...props}
            />
        </ConditionalWrapper>
    );
};

export default CustomerSelector;
